<template>
  <div class="HtmlPreviewViewToggle">
    <UIButton
      v-if="isPreviewMode"
      class="HtmlPreviewViewToggle__button"
      size="sm"
      theme="secondary"
      leadIcon="squareCodeRegular"
      @click="previewStore.setHtmlViewMode('code')"
    >
      Show code
    </UIButton>
    <UIButton
      v-else
      class="HtmlPreviewViewToggle__button"
      size="sm"
      theme="primary"
      leadIcon="tableLayoutRegular"
      @click="previewStore.setHtmlViewMode('preview')"
    >
      Show preview
    </UIButton>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { UIButton } from '@foundever/ui-lib'
import { storeToRefs } from 'pinia'

import { usePreviewStore } from '@/store/preview'

const previewStore = usePreviewStore()
const { htmlViewMode } = storeToRefs(previewStore)

const isPreviewMode = computed(() => htmlViewMode.value === 'preview')
</script>

<style lang="scss" scoped>
.HtmlPreviewViewToggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

.HtmlPreviewViewToggle__button {
  border-radius: 999px;
}
</style>
